const testingStructureUrls = {
    fetchTestingStructures: {
        url: '/testing/structure/'
    },
    fetchTestingStructure: {
        url: '/testing/structure/:id'
    },
    fetchStructureFormOptions: {
        url: '/testing/actions/structureFormOptions'
    },
    fetchTest: {
        url: '/testing/structure/tests/:id'
    },
    fetchResource: {
        url: '/testing/structure/resources/:id'
    },
    fetchStructureResourceOptions:{
        url: '/testing/actions/structureResourceOptions'
    }

};
export default testingStructureUrls;